import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ModalPortal from '../../../../../../../components/modal-portal';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { useSalesOrderIdContext } from '../../../../../../context/sales-order-id-context-provider';
import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlan } from '../../../../../../../hooks/entities/selectors/fulfillment-plans';
import EditShipToFormProvider from './context';
import EditShipToModalBody from './modal-body';
import EditShipToModalFooter from './modal-footer';
import messages from '../messages';

const EditShipToModal = ({ onClose }) => {
  const salesOrderId = useSalesOrderIdContext();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { shipTo, recipientInfo, lockAddress } = useEntitiesFulfillmentPlan(fulfillmentPlanId);
  const { email } = recipientInfo;

  const initialFormState = useMemo(
    () => ({
      ...shipTo,
      email,
      lockAddress,
    }),
    [email, shipTo, lockAddress],
  );

  return (
    <ModalPortal onClose={onClose}>
      <Modal size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.modalTitle} />
        </ModalHeader>
        <EditShipToFormProvider fulfillmentPlanId={fulfillmentPlanId} initialShipTo={initialFormState} salesOrderId={salesOrderId}>
          <EditShipToModalBody />
          <EditShipToModalFooter onClose={onClose} />
        </EditShipToFormProvider>
      </Modal>
    </ModalPortal>
  );
};

EditShipToModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default EditShipToModal;
